import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import {AdalService } from './services/adal.service'

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(private oauthService: OAuthService, private adalService: AdalService, private router: Router) {

    if (this.adalService.isCallback(window.location.hash)) {
      console.log('callback detected...');
      //console.log(window.location.hash);
      debugger;
      this.adalService.handleWindowCallback();
    }
    else {
      console.log('Not a callback'); 
      //adalService.login();
    }


    if (!this.adalService.isAuthenticated) {
      console.log('User not logged in');
    } else {
      console.log(adalService.accessToken); 
    }    

}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts